import { useState, useCallback } from "react";

export const useForceRerender = () => {
  const [, setter] = useState(Object.create(null));
  return useCallback(() => setter(Object.create(null)), []);
};
